export enum AppNames {
    CabSupport = 'CabSupport',
    CabChat = 'CabChat',
}
